import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
// import { axiosGet, axiosPost } from '../utils/axios'
// import apiRouter from '../utils/apiRouter'

interface notificationProps {
  name: string;
  value: number;
}

interface filterProps {
  filters: [];
  sort: [];
  hideColumns: [],
}

interface attendantUserSummaryRow {
  label: string;
  minutes: number;
  periods: number;
  compliant: string;
  billable: string;
}

interface initialStateInt {
  isLoading: boolean;
  timezoneArr: any[];
  showSidebar: any;
  windowWidth: any;
  isMobile: boolean;
  twilioAuthToken: string;
  notificationData: notificationProps[];
  wrapperType: any;
  ccmConsentData: [],
  ccmEligibleData: [],
  recordableMinutesData: [],
  recordingStatusList: [],
  userTypes: [],
  providerTypes: [],
  faxTemplateType: [],
  faxDestinationType: [],
  stateList: [],
  providerList: [],
  relationshipList: [],
  reportAdvocateList: [],
  agencyTypes: [],
  overviewType: '',
  filtersObj: filterProps,
  overviewMeasurementValues: [],
  menus: [],
  patientEvents: [],
  organizationList: [],
  campaignList: [],
  makeCallAlert: boolean,
  calleeUser: {},
  isVideoCall: boolean,
  insuranceList: [],
  icdCodesList: [],
  presetNotesList: any[],
  authUserAllData: {},
  authPermissions: string[],
  isCustomPatientChartOpen: boolean,
  chartPatientDetails: any,
  todayTotalTime: string,
  isPatientChartAlreadyOpen: boolean,
  isTimerChartOpen: boolean,
  customPatientId: number,
  claimJob: {
    id: string;
    total: number;
    processed: number;
    status: string;
  } | null,
  setupClaimJob: {
    id: string;
    total: number;
    processed: number;
    status: string;
  } | null,
  telehealthClaimJob: {
    id: string;
    total: number;
    processed: number;
    status: string;
  } | null,
  ccmClaimJob: {
    id: string;
    total: number;
    processed: number;
    status: string;
  } | null,
  needToCallPatientChartClose: {
    isNeedToCall: boolean,
    callBackType: string
  },
  signOffStats: {
    periods: number,
    carePlans: number,
    rtmPeriods: number,
    total: number
  },
  unsubmittedBillingStats: {
    'ccmMonthly': number,
    'rpmMonthly': number,
    'rpmSetup': number,
    'rpmTelehealth': number,
    'rtmMonthly': number,
    'total': number
  },
  attendantUserSummary: attendantUserSummaryRow[]
}

// initial state
const initialState: initialStateInt = {
  isLoading: true,
  timezoneArr: [],
  showSidebar: 'show-menu',
  windowWidth: window.innerWidth,
  isMobile: window.innerWidth <= 768,
  twilioAuthToken: '',
  notificationData: [],
  wrapperType: 'wrapper_fix',
  ccmConsentData: [],
  ccmEligibleData: [],
  recordableMinutesData: [],
  recordingStatusList: [],
  userTypes: [],
  providerTypes: [],
  faxTemplateType: [],
  faxDestinationType: [],
  stateList: [],
  providerList: [],
  relationshipList: [],
  reportAdvocateList: [],
  agencyTypes: [],
  overviewType: '',
  filtersObj: { filters: [], sort: [], hideColumns: [] },
  overviewMeasurementValues: [],
  menus: [],
  patientEvents: [],
  organizationList: [],
  campaignList: [],
  makeCallAlert: false,
  calleeUser: {},
  isVideoCall: false,
  insuranceList: [],
  icdCodesList: [],
  presetNotesList: [],
  authUserAllData: {},
  authPermissions: [],
  isCustomPatientChartOpen: false,
  chartPatientDetails: {},
  todayTotalTime: '00:00:00',
  isPatientChartAlreadyOpen: false,
  isTimerChartOpen: false,
  customPatientId: 0,
  claimJob: null,
  setupClaimJob: null,
  telehealthClaimJob: null,
  ccmClaimJob: null,
  needToCallPatientChartClose: {
    isNeedToCall: false,
    callBackType: ''
  },
  signOffStats: {
    periods: 0,
    carePlans: 0,
    total: 0,
    rtmPeriods: 0
  },
  unsubmittedBillingStats: {
    ccmMonthly: 0,
    rpmMonthly: 0,
    rpmSetup: 0,
    rpmTelehealth: 0,
    rtmMonthly: 0,
    total: 0
  },
  attendantUserSummary: []
};

// methods
// export const getTasksCount = createAsyncThunk(
//   'tasks/tasksCount',
//   async (credentials: any) => {
//     const taskDetails = await axiosGet(
//       apiRouter.TASK_BASE_URL, null
//     )
//     if (taskDetails.status) {
//       return taskDetails.data.total
//     }
//   }
// );
// states
export const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setIsLoading: (state, { payload }) => {
      state.isLoading = payload
    },
    setTimezoneArr: (state, { payload }) => {
      state.timezoneArr = payload
    },
    showSidebarChange: (state, { payload }) => {
      state.showSidebar = payload
    },
    setWindowWidth: (state, { payload }) => {
      state.windowWidth = payload
    },
    checkIsMobile: (state, { payload }) => {
      state.isMobile = state.windowWidth <= 768
    },
    setTwilioAuthToken: (state, { payload }) => {
      state.twilioAuthToken = payload
    },
    setNotificationData: (state, { payload }) => {
      state.notificationData = payload
    },
    setWrapperChange: (state, { payload }) => {
      state.wrapperType = payload
    },
    setCcmConsentData: (state, { payload }) => {
      state.ccmConsentData = payload
    },
    setCcmEligibleData: (state, { payload }) => {
      state.ccmEligibleData = payload
    },
    setRecordableMinutes: (state, { payload }) => {
      state.recordableMinutesData = payload
    },
    setRecordingStatus: (state, { payload }) => {
      state.recordingStatusList = payload
    },
    setUserTypes: (state, { payload }) => {
      state.userTypes = payload
    },
    setProviderTypes: (state, { payload }) => {
      state.providerTypes = payload
    },
    setFaxTemplateType: (state, { payload }) => {
      state.faxTemplateType = payload
    },
    setFaxDestinationType: (state, { payload }) => {
      state.faxDestinationType = payload
    },
    setStateList: (state, { payload }) => {
      state.stateList = payload
    },
    setProviderList: (state, { payload }) => {
      state.providerList = payload // for provider which at provider grid
    },
    setRelationships: (state, { payload }) => {
      state.relationshipList = payload
    },
    setReportAdvocateList: (state, { payload }) => {
      state.reportAdvocateList = payload
    },
    setAgencyTypes: (state, { payload }) => {
      state.agencyTypes = payload
    },
    setOverviewType: (state, { payload }) => {
      state.overviewType = payload
    },
    setFilters: (state, { payload }) => {
      state.filtersObj = payload
    },
    setOverviewMeasurementValues: (state, { payload }) => {
      state.overviewMeasurementValues = payload
    },
    setMenus: (state, { payload }) => {
      state.menus = payload
    },
    setPatientEvents: (state, { payload }) => {
      state.patientEvents = payload
    },
    setOrganizationList: (state, { payload }) => {
      state.organizationList = payload
    },
    setCampaignList: (state, { payload }) => {
      state.campaignList = payload
    },
    setMakeCallAlert: (state, { payload }) => {
      state.makeCallAlert = payload
    },
    setCalleeUser: (state, { payload }) => {
      state.calleeUser = payload
    },
    setIsVideoCall: (state, { payload }) => {
      state.isVideoCall = payload
    },
    setInsuranceList: (state, { payload }) => {
      state.insuranceList = payload
    },
    setIcdCodesList: (state, { payload }) => {
      state.icdCodesList = payload
    },
    setPresetNotesList: (state, { payload }) => {
      state.presetNotesList = payload ?? []
    },
    setAuthUserAllData: (state, { payload }) => {
      state.authUserAllData = payload
    },
    setAuthPermissions: (state, { payload }) => {
      state.authPermissions = payload
    },
    setIsChartOpen: (state, { payload }) => {
      state.isCustomPatientChartOpen = payload
    },
    setCustomPatientId: (state, { payload }) => {
      state.customPatientId = payload
    },
    setChartPatientDetails: (state, { payload }) => {
      state.chartPatientDetails = payload
    },
    seUserTodayTotalTime: (state, { payload }) => {
      state.todayTotalTime = payload
    },
    setIsPatientChartAlreadyOpen: (state, { payload }) => {
      state.isPatientChartAlreadyOpen = payload
    },
    setIsTimerChartOpen: (state, { payload }) => {
      state.isTimerChartOpen = payload
    },
    setClaimJob: (state, { payload }) => {
      state.claimJob = payload
    },
    setSetupClaimJob: (state, { payload }) => {
      state.setupClaimJob = payload
    },
    setTelehealthClaimJob: (state, { payload }) => {
      state.telehealthClaimJob = payload
    },
    resetJobsState: (state: any) => {
      state.setupClaimJob = null
      state.telehealthClaimJob = null
      state.claimJob = null
      state.ccmClaimJob = null
    },
    setCCMClaimJob: (state, { payload }) => {
      state.ccmClaimJob = payload
    },
    setNeedToCallPatientChartClose: (state, { payload }) => {
      state.needToCallPatientChartClose = payload
    },
    setSignOffStats: (state, { payload }) => {
      state.signOffStats = payload
    },
    setUnsubmittedBillingStats: (state, { payload }) => {
      state.unsubmittedBillingStats = payload
    },
    setAttendantUserSummary: (state, { payload }) => {
      state.attendantUserSummary = payload
    }
  }
})
  //   extraReducers: (builder) => {
  //     builder.addCase(getTasksCount.pending, (state) => {
  //       state.taskCount = 'loading...'
  //     })
  //     builder.addCase(getTasksCount.fulfilled, (state, { payload }) => {
  //       state.taskCount = payload
  //     })
  //     builder.addCase(getTasksCount.rejected, (state) => {
  //       state.taskCount = ''
  //     })
  //   }
// export const allUsers = (state) =>

export const { setIsLoading, setTimezoneArr, showSidebarChange, setWindowWidth, checkIsMobile, setTwilioAuthToken, setNotificationData, setWrapperChange, setCcmConsentData, setCcmEligibleData, setRecordableMinutes, setRecordingStatus, setUserTypes, setProviderTypes, setFaxTemplateType, setFaxDestinationType, setStateList, setProviderList, setRelationships, setReportAdvocateList, setAgencyTypes, setOverviewType, setFilters, setOverviewMeasurementValues, setMenus, setPatientEvents, setOrganizationList, setCampaignList, setMakeCallAlert, setCalleeUser, setIsVideoCall, setInsuranceList, setIcdCodesList, setPresetNotesList, setAuthUserAllData, setAuthPermissions, setIsChartOpen, setChartPatientDetails, seUserTodayTotalTime, setIsPatientChartAlreadyOpen, setIsTimerChartOpen, setCustomPatientId, setClaimJob, setSetupClaimJob, setTelehealthClaimJob, resetJobsState, setCCMClaimJob, setNeedToCallPatientChartClose, setSignOffStats, setUnsubmittedBillingStats, setAttendantUserSummary } = globalSlice.actions

export const globalState = (state: any) => state.global

export default globalSlice.reducer
